module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/array/from.js
// module id = 224
// module chunks = 35783957827783 70144966829960 114276838955818